/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Italic",
  size: 20
}

const SvgItalic = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <path d="M12.63 5.48l-2.48 9.04c-.15.56.22.73 1.77.78l-.2.7H6l.2-.69c1.58-.05 1.99-.22 2.14-.78l2.48-9.04c.15-.57-.19-.73-1.73-.78L9.28 4H15l-.19.69c-1.58.06-2.03.22-2.18.79z" />
  </Svg>
)

SvgItalic.defaultProps = defaultProps
export default SvgItalic
